import Reveal from "./Reveal";

const PARTNERS = [
  { name: "Swisscom", logo: "/logos/swisscom.png" },
  { name: "Allianz", logo: "/logos/allianz.png" },
  { name: "Zurich", logo: "/logos/zurich.png" },
  { name: "AkzoNobel", logo: "/logos/akzonobel.png" },
];

export default function PartnerCarousel() {
  return (
    <section
      className="sdx partner-carousel"
      aria-labelledby="partner-carousel-title"
      style={{
        overflow: "hidden",
        padding: "2.5rem 1.5rem 1.75rem",
        textAlign: "center",
        width: "100%",
      }}
    >
      <Reveal>
        <h2
          id="partner-carousel-title"
          className="h2 lp-accent"
          style={{
            color: "#004A53",
            display: "block",
            margin: "0 0 1.75rem",
            textAlign: "center",
            width: "100%",
          }}
        >
          Gemeinsam entwickelt von
        </h2>
      </Reveal>

      <div className="partner-carousel-viewport">
        <div className="partner-carousel-track">
          {[false, true].map(isDuplicate => (
            <div
              className="partner-carousel-group"
              key={String(isDuplicate)}
              aria-hidden={isDuplicate || undefined}
            >
              {PARTNERS.map(partner => (
                <div className="partner-carousel-slot" key={partner.name}>
                  <PartnerLogo partner={partner} isDuplicate={isDuplicate} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .partner-carousel-viewport {
          margin: 0 auto;
          max-width: 720px;
          overflow: hidden;
        }

        .partner-carousel-track {
          display: flex;
          width: 200%;
          animation: partner-carousel-scroll 10s linear infinite;
        }

        .partner-carousel-group {
          display: flex;
          flex: 0 0 50%;
          min-width: 0;
        }

        .partner-carousel-slot {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 25%;
          min-width: 0;
          height: 100px;
        }

        .partner-carousel-logo {
          height: 64px;
          width: 84%;
          max-width: 150px;
          object-fit: contain;
        }

        @keyframes partner-carousel-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }

        @media (prefers-reduced-motion: reduce) {
          .partner-carousel-track { animation: none; }
        }
      `}</style>
    </section>
  );
}

function PartnerLogo({ partner, isDuplicate }) {
  return (
    <img
      className="partner-carousel-logo"
      src={partner.logo}
      alt={isDuplicate ? "" : partner.name}
    />
  );
}
